var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"form"},[_c('v-row',[_c('v-col',[_c('v-text-field',{attrs:{"label":"Name","outlined":"","dense":"","hide-details":"auto","clearable":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }